import { Icon, Tooltip, Box } from '@chakra-ui/react';
import { TbBan, TbX, TbStar, TbStars, TbCheck } from 'react-icons/tb';
import { VendorType } from '../hooks/useGetSettings';

interface VendorTypeIconProps {
    type: VendorType;
    size?: number;
}

const config: Record<VendorType, { icon: React.ElementType; color: string; label: string }> = {
    avoid: { icon: TbX as React.ElementType, color: 'red.500', label: 'Avoid' },
    preferred: { icon: TbStar as React.ElementType, color: 'yellow.500', label: 'Preferred' },
    'super-preferred': { icon: TbStars as React.ElementType, color: 'orange.500', label: 'Super Preferred' },
    required: { icon: TbCheck as React.ElementType, color: 'green.500', label: 'Required' },
    prohibited: { icon: TbBan as React.ElementType, color: 'purple.500', label: 'Prohibited' },
};

const VendorTypeIcon = ({ type, size = 4 }: VendorTypeIconProps) => {
    const { icon, color, label } = config[type];

    return (
        <Tooltip label={label} placement="top" hasArrow>
            <Box display="inline-flex">
                <Icon as={icon} w={size} h={size} color={color} />
            </Box>
        </Tooltip>
    );
};

export default VendorTypeIcon;
